import { create } from 'zustand';

export const useSignUpStore = create((set, _, store) => ({
  subscriptionTypeId: null,
  email: '',
  existingAccount: null,

  setSubscriptionTypeId: (subscriptionTypeId) => {
    set({ subscriptionTypeId });
  },

  setEmail: (email) => {
    set({ email });
  },

  setExistingAccount: (existingAccount) => {
    set({ existingAccount });
  },

  reset: () => {
    set(store.getInitialState());
  },
}));
